import { useNavigate } from 'react-router-dom';

const SEGMENTS = [
  { icon: 'ri-hospital-line', label: 'Operadoras de planos de saúde' },
  { icon: 'ri-stethoscope-line', label: 'Clínicas e hospitais' },
  { icon: 'ri-capsule-line', label: 'Farmácias e redes' },
  { icon: 'ri-test-tube-line', label: 'Laboratórios' },
];

export default function HealthAuthorityBand() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto mb-12 w-full max-w-[1240px] px-6">
      <div className="grid overflow-hidden rounded-3xl border border-background-200 bg-background-100 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="relative min-h-[260px] lg:min-h-[420px]">
          <img
            src="https://public.readdy.ai/ai/img_res/edited_ae9c4279f41566fbf3c5bdd01ba4f7d9_a6f716f0.jpg"
            alt="Corretor de vendas apresentando um plano de saúde para clientes"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/10 to-transparent"></div>
          <div className="absolute bottom-4 left-4 rounded-full bg-background-50/90 px-4 py-2 text-xs font-semibold text-foreground-900 backdrop-blur-sm">
            +12 anos no setor de saúde
          </div>
        </div>

        <div className="flex flex-col justify-center p-7 md:p-10">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-700">
            <i className="ri-heart-pulse-line"></i>
            Nossa especialidade
          </span>

          <h3 className="mt-5 font-heading text-2xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-3xl">
            Especialistas em incentivo e fidelização para o <span className="text-accent-600">setor de saúde</span>
          </h3>

          <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
            Engajamos beneficiários, equipes e redes credenciadas com programas de incentivo sob medida, que reduzem sinistralidade e aumentam a retenção.
          </p>

          <div className="mt-6 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
            {SEGMENTS.map((segment) => (
              <div key={segment.label} className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${segment.icon} text-base`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800">{segment.label}</span>
              </div>
            ))}
          </div>

          <button
            type="button"
            onClick={() => navigate('/saude')}
            className="mt-8 inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
          >
            Conhecer soluções em saúde
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>
      </div>
    </div>
  );
}